
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--datepicker ${
        isMultiple && 'condition-item--datepicker-range'
    } condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <ElDatePicker
        v-bind="contentProps"
        v-on="$listeners"
        :disabled="insetDisabled"
        :value="checked"
        class="condition-item__content"
        @input="change"
    ></ElDatePicker>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else><component :is="getNode(postfix, checked)"></component></template>
    </div>
</ElFormItem>
